<template>
    <div class="building-fields">
        <div v-if="showHeader" class="tab-header">
            <div class="tab-header-left">
                <h3 class="tab-title">Building Information</h3>
                <span v-if="building.type" class="tab-type-badge">
                    {{ building.type.type }}
                </span>
            </div>
            <themed-button 
                v-if="canEditBuilding() && !fromReatlas" 
                @click="launchEditBuilding" 
                variant="default"
            >
                <span>Edit Building</span>
            </themed-button>
        </div>

        <div v-if="buildingFields.length" class="building-fields__content">
            <!-- Main Building Data Grid -->
            <div class="building-fields__grid">
                <div 
                    v-for="row in buildingFields" 
                    :key="row.field"
                    class="building-fields__card"
                >
                    <div class="building-fields__card-value">
                        <span v-if="building[row.field] == null">-</span>
                        <span v-else-if="row.type == 'integer' || row.type == 'double'">
                            {{ building[row.field] | number(row.type == 'double' ? 1 : 0) }}
                        </span>
                        <span v-else-if="row.type == 'currency'" data-precision="2" :data-originalvalue="building[row.field] * 100" class="is-currency">
                            {{ formatCurrency(building[row.field] * 100, 2) }}
                        </span>
                        <span v-else-if="row.type == 'percentage'">
                            {{ building[row.field] | number }}%
                        </span>
                        <span v-else>{{ building[row.field] || '-' }}</span>
                    </div>
                    <div class="building-fields__card-label">{{ row.label }}</div>
                </div>
            </div>

            <!-- Amenities/Toggle Fields Section -->
            <div v-if="buildingToggleFields.length" class="building-fields__amenities">
                <h4 class="building-fields__amenities-title">Amenities</h4>
                <div class="building-fields__amenities-grid">
                    <div 
                        v-for="row in buildingToggleFields" 
                        :key="row.field"
                        class="building-fields__amenity-card"
                    >
                        <theme-icon 
                            v-if="building[row.field]" 
                            icon="check-icon" 
                            type="icons" 
                            class="building-fields__amenity-icon building-fields__amenity-icon--available"
                            classes="w-5 h-5"
                        />
                        <theme-icon 
                            v-else 
                            icon="x-circle" 
                            type="icons" 
                            class="building-fields__amenity-icon building-fields__amenity-icon--unavailable"
                            classes="w-5 h-5"
                        />
                        <span class="building-fields__amenity-label">{{ row.label }}</span>
                    </div>
                </div>
            </div>
        </div>

        <modal name="manage-units" width="50%" height="auto" draggable=".modal-header">
            <manage-units></manage-units>
        </modal>
    </div>
</template>

<script>
    export default {
        name: 'BuildingFields',

        props: {
            buildingData: {
                type: Object,
                required: true
            },

            showHeader: {
                type: Boolean,
                default: true
            },

            fromReatlas: {
                type: Boolean,
                default: false
            },

            fromSiteId: {
                type: Number,
                required: false
            }
        },

        data() {
            return {
                buildingTypes: {}
            }
        },

        created() {
            this.initBuildingTypes();
        },

        computed: {
            building() {
                return this.buildingData;
            },

            buildingFields() {
                if (this.buildingTypes.length && this.building.type_id != null) {
                    let fields = _.clone(_.find(this.buildingTypes, ['id', this.building.type_id]).fields);

                    return _.remove(fields, (field) => {
                        return field.type != 'boolean'
                    });
                }

                return [];
            },

            buildingToggleFields() {
                if (this.buildingTypes.length && this.building.type_id != null) {
                    let fields = _.find(this.buildingTypes, ['id', this.building.type_id]).fields;

                    return _.remove(fields, (field) => {
                        return field.type == 'boolean'
                    });
                }

                return [];
            }
        },

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types').then((response) => {
                    this.buildingTypes = response.data.types;
                }).catch((error) => {
                    console.log(error);
                });
            },

            launchEditBuilding() {
                window.location = '/buildings/' + this.building.id + '/edit' + (!isNaN(this.fromSiteId) ? '?siteId=' + this.fromSiteId : '');
            },

            canEditBuilding() {
                return this.$gate.can('edit', 'site', this.site);
            }
        }
    }
</script>
